import { render, staticRenderFns } from "./OrderTotals.vue?vue&type=template&id=0d98fb8d&"
import script from "./OrderTotals.vue?vue&type=script&lang=ts&"
export * from "./OrderTotals.vue?vue&type=script&lang=ts&"
import style0 from "./OrderTotals.vue?vue&type=style&index=0&id=0d98fb8d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports